<template>
  <v-container>
    <v-navigation-drawer
      disable-resize-watcher
      v-model="drawerRight"
      fixed
      right
      width="350"
      class="pa-6"
    >
      <div class="pb-3">
        <h3>
          {{$t('profile')}}
          <span class="float-right">
            <v-btn icon @click="closeDrawer">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </span>
        </h3>
      </div>


      <v-list class="pl-0">
        <v-list-group v-model="active" disabled class="hide-icon">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>{{$t('user_profile')}}</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item class="ml-5">
            <v-list-item-content>
              <v-list-item-subtitle>{{$t('full_name')}}</v-list-item-subtitle>
              <v-list-item-title>{{user.name}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item class="ml-5">
            <v-list-item-content>
              <v-list-item-subtitle>{{$t('email')}}</v-list-item-subtitle>
              <v-list-item-title>{{user.email}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item class="ml-5">
            <v-list-item-content>
              <v-list-item-subtitle>{{$t('job_position')}}</v-list-item-subtitle>
              <v-list-item-title>{{user.detail.jobPosition}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item class="ml-5">
            <v-list-item-content>
              <v-list-item-subtitle>{{$t('access_type')}}</v-list-item-subtitle>
              <v-list-item-title>{{user.detail.accessType}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item class="ml-5">
            <v-list-item-content>
              <v-list-item-subtitle>{{$t('company_name')}}</v-list-item-subtitle>
              <v-list-item-title>{{companies.name_company}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>

      <v-divider></v-divider>

      <v-list class="pl-0">
        <v-list-group v-model="active" disabled class="hide-icon">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>{{$t('summary_report_title')}}</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item class="ml-5">
            <v-list-item-content>
              <v-list-item-subtitle>{{$t('groupName')}}</v-list-item-subtitle>
              <v-list-item-title>{{user.detail.group}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-for="(item,i) in user.detail.zone" v-bind:key="i" class="ml-5">
            <v-list-item-content>
              <v-list-item-subtitle>{{$t('zones')}} {{user.detail.zone.length > 1 ? (i+1): ''}}</v-list-item-subtitle>
              <v-list-item-title>{{item.zone_master.zonename}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>

      <!-- <v-divider></v-divider>
      <v-row>
        <v-col md="6"></v-col>
        <v-col md="6">
          <v-btn block outlined text @click="closeDrawer">Close</v-btn>
        </v-col>
      </v-row> -->
    </v-navigation-drawer>
  </v-container>
</template>
<script>
export default {
  name: "company-data",
  data() {
    return {
      active:true,
      isAdmin: false,
      isEdit: false,
      loading: false,
      dialog: false,
      drawerRight: false,
      drawerLoading: false,
      updateLoading: false,
      companies: [],
      editingData: {},
    };
  },
  methods: {
    showDrawer(company) {
      this.editingData = company;
    },
    closeDrawer() {
      this.$store.dispatch("profileDrawer", false);
    },
    async getCompanies() {
      const result = await this.$store.state.companyDetail
      this.companies = result
    },
   
  },
  created() {
    this.getCompanies();
    let role = this.$store.state.role;
    if (role != 3 || role != 4) {
      this.isAdmin = true
    }
    this.user = this.$store.state.user
  },
  computed: {
    openDrawer() {
      return this.$store.state.profileDrawer;
    }
  },
  watch: {
    openDrawer(newValue) {
      this.drawerRight = newValue
      if (newValue == true) {
        this.showDrawer(this.companies)
      } else {
        this.closeDrawer()
      }
    }
  }

};
</script>
<style> 
.hide-icon .v-list-item__icon{
  display: none;
}

</style>
